import { SkeletonBlock } from "@/components/podkit/loading/Skeleton";
import type { FC } from "react";

const ready = false;

/** Mirrors the StatRow layout: label left, value placeholder right. h-5 matches text-base line height (20px). */
const StatRowSkeleton: FC<{ labelWidth: string; valueWidth: string }> = ({ labelWidth, valueWidth }) => (
    <div className="flex items-baseline justify-between gap-x-2">
        <SkeletonBlock ready={ready} className="h-5 rounded" style={{ width: labelWidth }} />
        <SkeletonBlock ready={ready} className="h-5 rounded" style={{ width: valueWidth }} />
    </div>
);

/** Mirrors the UsageBar layout: label + value row, then a progress bar */
const UsageBarSkeleton: FC<{ labelWidth: string; valueWidth: string }> = ({ labelWidth, valueWidth }) => (
    <div className="flex flex-col gap-1.5">
        <div className="flex items-baseline justify-between gap-x-2">
            <SkeletonBlock ready={ready} className="h-5 rounded" style={{ width: labelWidth }} />
            <SkeletonBlock ready={ready} className="h-5 rounded" style={{ width: valueWidth }} />
        </div>
        <SkeletonBlock ready={ready} className="h-2 w-full rounded-full" />
    </div>
);

export const ResourceUsageSkeleton: FC = () => (
    <div className="flex flex-col gap-5">
        {/* CPU */}
        <UsageBarSkeleton labelWidth="36px" valueWidth="52px" />
        {/* Memory */}
        <UsageBarSkeleton labelWidth="60px" valueWidth="130px" />
        {/* Disk */}
        <UsageBarSkeleton labelWidth="40px" valueWidth="130px" />
        {/* Disk Read, Disk Write */}
        <div className="flex flex-col gap-1">
            <StatRowSkeleton labelWidth="72px" valueWidth="110px" />
            <StatRowSkeleton labelWidth="76px" valueWidth="110px" />
        </div>
        {/* Load average (with border separator) */}
        <div className="border-t border-border-base pt-5">
            <StatRowSkeleton labelWidth="190px" valueWidth="150px" />
        </div>
        {/* Footer: "Updated Xs ago" + Refresh button */}
        <div className="flex items-center justify-between border-t border-border-base pt-5">
            <SkeletonBlock ready={ready} className="h-5 rounded" style={{ width: "130px" }} />
            <SkeletonBlock ready={ready} className="h-8 rounded" style={{ width: "90px" }} />
        </div>
    </div>
);
